"use strict";

module.exports = require("./is-implemented")()
	? Number.isNaN
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/number/is-nan/index.js
// module id = 722
// module chunks = 0